"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plantation = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
const TileType_1 = require("../../TileType");
class Plantation extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PLANTATION,
            tags: [Tags_1.Tags.PLANT],
            cost: 15,
            tr: { oxygen: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE, 2)),
            metadata: {
                cardNumber: '193',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.greenery();
                }),
                description: 'Requires 2 Science tags. Place a greenery tile and raise oxygen 1 step.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (player.game.board.getAvailableSpacesOnLand(player).length === 0) {
            return false;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        return new SelectSpace_1.SelectSpace('Select space for greenery tile', player.game.board.getAvailableSpacesForGreenery(player), TileType_1.TileType.GREENERY, (space) => {
            return player.game.addGreenery(player, space.id);
        });
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromOxygenIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({
            card: card,
            oxygenIncrease: 1,
            nonOceanToPlace: TileType_1.TileType.GREENERY,
            nonOceanAvailableSpaces: player.game.board.getAvailableSpacesForGreenery(player),
            bonusMegaCredits: bonusMegaCredits,
        });
    }
}
exports.Plantation = Plantation;
//# sourceMappingURL=Plantation.js.map